<template>
    <v-form
        v-model="subscribeValid"
        class="d-flex mx-md-0 mx-auto align-center"
        :action="mailChimpLink"
        method="post"
        name="mc-embedded-subscribe-form"
        target="_blank"
        novalidate
    >
        <v-text-field
            name="EMAIL"
            :rules="validationRules('email', [emailRule, requiredRule])"
            hide-details
            density="compact"
            variant="outlined"
            type="email"
            :placeholder="$t('email')"
        />
        <v-btn class="ms-2" color="primary" type="submit" :disabled="!subscribeValid">
            {{ $t('subscribe') }}
        </v-btn>
    </v-form>
</template>

<script lang="ts">
    import {Component, mixins, Prop} from 'vue-facing-decorator'
    import {FormValidationRulesMixin} from '@/mixins/FormValidationRulesMixin.vue'

    @Component
    export class MailChimpForm extends mixins(FormValidationRulesMixin) {
        @Prop() mailChimpLink

        subscribeValid = false
    }

    export default MailChimpForm
</script>

<style scoped lang="scss">
    .v-text-field {
        width: 200px;
    }
</style>
